export const LOCATION_IS_DASHBOARD_JWPLAYER_COM = window.location.hostname.endsWith('dashboard.jwplayer.com');
export const LOCATION_IS_LOCAL_DASH = window.location.hostname === 'local-dashboard.jwplayer.com';
export const LOCATION_IS_LOCALHOST = window.location.hostname === 'localhost';
export const LOCATION_IS_JWPLAYER_COM = window.location.hostname.endsWith('jwplayer.com') && !LOCATION_IS_LOCAL_DASH;
